const FireproofingServices = () => {
  const services = [
    {
      icon: 'ri-spray-line',
      title: 'Spray Fireproofing',
      description: 'Spray-applied fire-resistive materials (SFRM) for structural steel protection in commercial buildings.'
    },
    {
      icon: 'ri-paint-line',
      title: 'Intumescent Coatings',
      description: 'Thin-film intumescent paint coatings that expand when exposed to heat, providing fire protection.'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Fire-Rated Assemblies',
      description: 'Installation of fire-rated walls, floors, and ceiling assemblies meeting UL and building code requirements.'
    },
    {
      icon: 'ri-shield-flash-line',
      title: 'Firestop Systems',
      description: 'Firestopping penetrations and joints to prevent fire and smoke spread through building openings.'
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Fire Safety Inspections',
      description: 'Comprehensive fire protection inspections and compliance assessments for existing buildings.'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Fireproofing Repair',
      description: 'Repair and restoration of damaged fireproofing materials to maintain fire rating integrity.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Fireproofing Services in El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From spray fireproofing to intumescent coatings and firestop systems, our network of certified fireproofing contractors provides complete fire protection solutions for commercial and industrial properties.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FireproofingServices;
